import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  IconButton,
  Stack,
} from "@mui/material";
import Buttons from "../../../components/Controls/Buttons/Button";
import BackButtons from "../../../components/Controls/Buttons/BackArrowButton";
import Label from "../../../components/Label/Label";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { TextField, MenuItem, InputAdornment } from "@mui/material";
import { invalidIds } from "../../../utility";
import { Autocomplete } from "@mui/material";

const DefinitionPopup = ({
  open,
  onClose,
  formData,
  errors,
  onChange,
  handleSubmit,
  sepcificaitonForm,
  fieldType,
  setFieldType,
  handleAcceptanceValueChange,
  handleDeleteAcceptanceValue,
  handleAddAcceptanceValue,
  handleBlockChange,
  handleDeleteBlock,
  handleAddBlock,
  parameter,
  limitOperation,
  handleSaveAsDraft,
  addTargetData,
  dropdownOption,
}) => {
  const [isEdit, setIsEdit] = React.useState(false);
  const specNames = [
    "IPL-Alert",
    "IPL-Action",
    "IPL-Accept",
    "IPM",
    "Spec-Release",
    "Spec-Stability",
    "AQL",
    "Internal - Release",
    "IPC",
  ];
  const handleClose = () => {
    setIsEdit(false);
    onClose();
  };

  useEffect(() => { }, [open]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      hideBackdrop
      disableEnforceFocus
      keepMounted={false}
      PaperProps={{
        sx: {
          position: "fixed",
          bottom: 0,
          right: 5,
          m: 0,
          width: isEdit ? 400 : 500,
          maxHeight: "calc(100% - 160px)",
          height: "100%",
          boxShadow: "none",
          elevation: 0,
          border: "1px solid #ccc",
          p: 1,
          transition: "width 0.3s ease",
        },
      }}
    >
      <>
        {" "}
        <>
          <DialogTitle className="dialog-title">
            <Label
              text={formData.unit_op_id ? "Update Unit Operation" : "Add Unit Operation"}
              color="#fff"
              fontSize="14px"
              fontWeight="500"
            ></Label>

            <BackButtons onClick={handleClose} />
          </DialogTitle>
          <DialogContent sx={{ padding: 0.5 }}>

            <>
              <Box
                sx={{
                  // width: 300,
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  paddingTop: 1,
                }}
              >
                <Label text='Unit Operation *'></Label>
                <TextField
                  variant="outlined"
                  // label="Product Name"
                  name="step_name"
                  fullWidth
                  value={formData?.step_name}
                  onChange={onChange}
                  required
                  error={!!errors?.step_name}
                  helperText={errors?.step_name}
                  size="small"
                  InputLabelProps={{
                    style: {
                      fontSize: "14px",
                      backgroundColor: "#fff",
                      padding: "0 4px",
                    },
                  }}
                >
                </TextField>

              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  paddingTop: 1,
                }}
              >
                <Label text="Product *" />

                <Autocomplete
                  size="small"
                  options={dropdownOption?.metalist?.data?.products || []}
                  getOptionLabel={(option) => option?.name || ""}
                  isOptionEqualToValue={(option, value) =>
                    String(option?.id) === String(value?.id)
                  }
                  value={
                    dropdownOption?.metalist?.data?.products?.find(
                      (item) => String(item.id) === String(formData?.product_id)
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    onChange({
                      target: {
                        name: "product_id",
                        value: newValue?.id || "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search Product"
                      error={!!errors?.product_id}
                      helperText={errors?.product_id}
                    />
                  )}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  paddingTop: 1,
                }}
              >
                <Label text="Site *" />

                <Autocomplete
                  size="small"
                  options={dropdownOption?.metalist?.data?.sites || []}
                  getOptionLabel={(option) => option?.name || ""}
                  isOptionEqualToValue={(option, value) =>
                    String(option?.id) === String(value?.id)
                  }
                  value={
                    dropdownOption?.metalist?.data?.sites?.find(
                      (item) => String(item.id) === String(formData?.site_id)
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    onChange({
                      target: {
                        name: "site_id",
                        value: newValue?.id || "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search Site"
                      error={!!errors?.site_id}
                      helperText={errors?.site_id}
                    />
                  )}
                />
              </Box>
            </>


          </DialogContent>
          <DialogActions
            sx={{
              justifyContent: "flex-start",
              p: 1,
              borderTop: "1px solid #ccc",
            }}
          >
            <Buttons
              size="small"
              text={formData.unit_op_id ? "Update" : "Submit"}
              onClick={handleSubmit}
              loading={dropdownOption?.adduop?.loading || dropdownOption?.updateuop?.loading}
            />
            {/* <Buttons
              size="small"
              text="Save Draft"
              onClick={handleSaveAsDraft}
              loading={limitOperation?.draftLoader}
            /> */}
            <Buttons
              size="small"
              colors="gray"
              text="Cancel"
              onClick={onClose}
            />
          </DialogActions>
        </>
      </>
    </Dialog>
  );
};

export default DefinitionPopup;
